<template>
  <main-layout>
	<section role="main" aria-label="תוכן" class="content" id="RhythmAudition">
			<div class="divider"></div>
			<div class="info-content">
				<div class="fill">
					<img :key=img2srcD src="photos/rhythm/pic01.jpg" alt="איך מצטרפים?" class="fillImgFront" >
				</div>
				<div class="textbox-bounds textbox-bounds-unbound-double">
						<div class="textbox-tab-mark""></div>
<div id="origamiform" data-origamiformname="form_6040df676c37c" data-origamiformid="f2be2d3fa03eafb5d6ee022c2c4fa7d649e9b7a67718f027da675d1179feef358807fa69235dc3bb5bd5bca8bed0c439b9040bfab13029f041cd075acf94b136Rc+sM89Tjvyjs4O9tsHPvuEEDLgeFvnxc4ugPGObWgD9fY/x3eNLAhwsoofOpdcLIpBShmOR4gIToydUSKNWq+sM3Am23IjkfaZcrDdaw+AtNGqPZO1LPpjPN4+UzXG2" ></div>
						<div class="textbox-text">
							
						</div>
					
				</div>
			</div>
			<br>
			<div id="FAQSdivider" class="divider"></div>
			
		</section>
  </main-layout>
</template>
<script>
var APIbase = "https://yard-bands.herokuapp.com"
import axios from 'axios'
  import MainLayout from '../layouts/Origami.vue'
   import VLink from '../components/VLink.vue'
  import VueScrollTo from 'vue-scrollto'

/* eslint-disable no-useless-escape */
import postscribe from 'postscribe'

  export default {
  mounted:function(){
    postscribe('#origamiform', '<script src="https://public.origamicloud.ms/web_forms/js"><\/script>')
    postscribe('#origamiform', '<script type="text/javascript"> ORIGAMI_FORMS["form_6040df676c37c"] = { "fields": { "Lead_First_name" : { "value" : "testing", "hidden" : true }, }, "rtl": "1" };  <\/script>')
  },
    components: {
      MainLayout,VLink
    },
	created () {
		this.texts = {}
	},
	ready:function(){
    },
	data() {
		return {
		}
	},
	watch: {

		
	},
	methods: {
		scrollToFooter(){
			this.$scrollTo(".credits", 0, {})
		}
	}

  }
</script>



// WEBPACK FOOTER //
// AuditionTrialQuestions.vue?1d1e25a0